import { __decorate } from 'tslib';
import { ElementRef, Directive, Input, Component, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import * as ɵngcc0 from '@angular/core';
import * as ɵngcc1 from '@angular/common';
var FaDirective_1;
let FaDirective = FaDirective_1 = class FaDirective {
    constructor(el) {
        this.el = el.nativeElement;
        this.el.classList.add("fa");
    }
    ngOnChanges(changes) {
        for (var key in changes) {
            var previousValue = changes[key].previousValue;
            var currentValue = changes[key].currentValue;
            switch (key) {
                case "name":
                    if (typeof previousValue === "string") {
                        this.el.classList.remove(`fa-${previousValue}`);
                    }
                    this.el.classList.add(`fa-${currentValue}`);
                    break;
                case "alt":
                    // TODO(Write code for the alt parameter)
                    break;
                case "size":
                    if (FaDirective_1.sizeValidator.test(currentValue)) {
                        if (previousValue === 1) {
                            this.el.classList.remove("fa-lg");
                        }
                        else if (typeof previousValue === "string") {
                            this.el.classList.remove(`fa-${previousValue}x`);
                        }
                        if (currentValue === 1) {
                            this.el.classList.add("fa-lg");
                        }
                        else {
                            this.el.classList.add(`fa-${currentValue}x`);
                        }
                    }
                    break;
                case "stack":
                    if (FaDirective_1.sizeValidator.test(currentValue)) {
                        if (typeof previousValue === "string") {
                            this.el.classList.remove(`fa-stack-${previousValue}x`);
                        }
                        this.el.classList.add(`fa-stack-${currentValue}x`);
                    }
                    break;
                case "flip":
                    if (FaDirective_1.flipValidator.test(currentValue)) {
                        if (typeof previousValue === "string") {
                            this.el.classList.remove(`fa-flip-${previousValue}`);
                        }
                        this.el.classList.add(`fa-flip-${currentValue}`);
                    }
                    break;
                case "pull":
                    if (FaDirective_1.pullValidator.test(currentValue)) {
                        if (typeof previousValue === "string") {
                            this.el.classList.remove(`fa-pull-${previousValue}`);
                        }
                        this.el.classList.add(`fa-pull-${currentValue}`);
                    }
                    break;
                case "rotate":
                    if (FaDirective_1.rotateValidator.test(currentValue)) {
                        if (typeof previousValue === "string") {
                            this.el.classList.remove(`fa-rotate-${previousValue}`);
                        }
                        this.el.classList.add(`fa-rotate-${currentValue}`);
                    }
                    break;
                case "border":
                    if (currentValue) {
                        this.el.classList.add("fa-border");
                    }
                    else if (typeof previousValue === "string") {
                        this.el.classList.remove("fa-border");
                    }
                    break;
                case "spin":
                    if (currentValue) {
                        this.el.classList.add("fa-spin");
                    }
                    else if (typeof previousValue === "string") {
                        this.el.classList.remove("fa-spin");
                    }
                    break;
                case "fw":
                    if (currentValue) {
                        this.el.classList.add("fa-fw");
                    }
                    else if (typeof previousValue === "string") {
                        this.el.classList.remove("fa-fw");
                    }
                    break;
                case "inverse":
                    if (currentValue) {
                        this.el.classList.add("fa-inverse");
                    }
                    else if (typeof previousValue === "string") {
                        this.el.classList.remove("fa-inverse");
                    }
                    break;
            }
        }
    }
};
FaDirective.ɵfac = function FaDirective_Factory(t) { return new (t || FaDirective)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef)); };
FaDirective.ɵdir = /*@__PURE__*/ ɵngcc0.ɵɵdefineDirective({ type: FaDirective, selectors: [["", "fa", ""]], inputs: { name: "name", alt: "alt", size: "size", stack: "stack", flip: "flip", pull: "pull", rotate: "rotate", border: "border", spin: "spin", fw: "fw", inverse: "inverse" }, features: [ɵngcc0.ɵɵNgOnChangesFeature] });
FaDirective.sizeValidator = new RegExp("/[1-5]/");
FaDirective.flipValidator = new RegExp("/['horizontal'|'vertical']/");
FaDirective.pullValidator = new RegExp("/['right'|'left']/");
FaDirective.rotateValidator = new RegExp("/[90|180|270]/");
FaDirective.ctorParameters = () => [
    { type: ElementRef }
];

var FaComponent_1;
const FA_COMPONENT_TEMPLATE = `
  <i [ngClass]="classList"></i>
`;
let FaComponent = FaComponent_1 = class FaComponent {
    constructor(el) {
        // TODO (travelist): Support for fa-li selector
        // if (el.nativeElement.tagName == 'FA')
        // else this.classList = ['fa', 'fa-li']
        this.classList = ["fa"];
    }
    ngOnChanges(changes) {
        for (var key in changes) {
            var previousValue = changes[key].previousValue;
            var currentValue = changes[key].currentValue;
            switch (key) {
                case "name":
                    this.removeFaClass(`fa-${previousValue}`);
                    this.addFaClass(`fa-${currentValue}`);
                    break;
                case "alt":
                    // TODO(travelist): Write code for the alt parameter
                    break;
                case "size":
                    if (FaComponent_1.sizeValidator.test(currentValue)) {
                        if (previousValue === 1) {
                            this.removeFaClass("fa-lg");
                        }
                        else {
                            this.removeFaClass(`fa-${previousValue}x`);
                        }
                        if (currentValue === 1) {
                            this.classList.push("fa-lg");
                        }
                        else {
                            this.classList.push(`fa-${currentValue}x`);
                        }
                    }
                    break;
                case "stack":
                    if (FaComponent_1.sizeValidator.test(currentValue)) {
                        this.removeFaClass(`fa-stack-${previousValue}x`);
                        this.addFaClass(`fa-stack-${currentValue}x`);
                    }
                    break;
                case "flip":
                    if (FaComponent_1.flipValidator.test(currentValue)) {
                        this.removeFaClass(`fa-flip-${previousValue}`);
                        this.addFaClass(`fa-flip-${currentValue}`);
                    }
                    break;
                case "pull":
                    if (FaComponent_1.pullValidator.test(currentValue)) {
                        this.removeFaClass(`fa-pull-${previousValue}`);
                        this.addFaClass(`fa-pull-${currentValue}`);
                    }
                    break;
                case "rotate":
                    if (FaComponent_1.rotateValidator.test(currentValue)) {
                        this.removeFaClass(`fa-rotate-${previousValue}`);
                        this.addFaClass(`fa-rotate-${currentValue}`);
                    }
                    break;
                case "border":
                    if (currentValue) {
                        this.addFaClass("fa-border");
                    }
                    else {
                        this.removeFaClass("fa-border");
                    }
                    break;
                case "spin":
                    if (currentValue) {
                        this.addFaClass("fa-spin");
                    }
                    else {
                        this.removeFaClass("fa-spin");
                    }
                    break;
                case "fw":
                    if (currentValue) {
                        this.addFaClass("fa-fw");
                    }
                    else {
                        this.removeFaClass("fa-fw");
                    }
                    break;
                case "inverse":
                    if (currentValue) {
                        this.addFaClass("fa-inverse");
                    }
                    else {
                        this.removeFaClass("fa-inverse");
                    }
                    break;
            }
        }
    }
    addFaClass(className) {
        // better to check uniqueness
        this.classList.push(className);
    }
    removeFaClass(className) {
        var index;
        if ((index = this.classList.indexOf(className)) >= 0) {
            this.classList.splice(index, 1);
        }
    }
};
FaComponent.ɵfac = function FaComponent_Factory(t) { return new (t || FaComponent)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef)); };
FaComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: FaComponent, selectors: [["fa"]], inputs: { name: "name", alt: "alt", size: "size", stack: "stack", flip: "flip", pull: "pull", rotate: "rotate", border: "border", spin: "spin", fw: "fw", inverse: "inverse" }, features: [ɵngcc0.ɵɵNgOnChangesFeature], decls: 1, vars: 1, consts: [[3, "ngClass"]], template: function FaComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelement(0, "i", 0);
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("ngClass", ctx.classList);
    } }, dependencies: [ɵngcc1.NgClass], encapsulation: 2 });
FaComponent.sizeValidator = new RegExp("/[1-5]/");
FaComponent.flipValidator = new RegExp("/['horizontal'|'vertical']/");
FaComponent.pullValidator = new RegExp("/['right'|'left']/");
FaComponent.rotateValidator = new RegExp("/[90|180|270]/");
FaComponent.ctorParameters = () => [
    { type: ElementRef }
];
__decorate([
    Input()
], FaComponent.prototype, "name", void 0);
__decorate([
    Input()
], FaComponent.prototype, "alt", void 0);
__decorate([
    Input()
], FaComponent.prototype, "size", void 0);
__decorate([
    Input()
], FaComponent.prototype, "stack", void 0);
__decorate([
    Input()
], FaComponent.prototype, "flip", void 0);
__decorate([
    Input()
], FaComponent.prototype, "pull", void 0);
__decorate([
    Input()
], FaComponent.prototype, "rotate", void 0);
__decorate([
    Input()
], FaComponent.prototype, "border", void 0);
__decorate([
    Input()
], FaComponent.prototype, "spin", void 0);
__decorate([
    Input()
], FaComponent.prototype, "fw", void 0);
__decorate([
    Input()
], FaComponent.prototype, "inverse", void 0);

//import { FaStackComponent } from './components/fa-stack.component';
let Angular2FontawesomeModule = class Angular2FontawesomeModule {
};
Angular2FontawesomeModule.ɵfac = function Angular2FontawesomeModule_Factory(t) { return new (t || Angular2FontawesomeModule)(); };
Angular2FontawesomeModule.ɵmod = /*@__PURE__*/ ɵngcc0.ɵɵdefineNgModule({ type: Angular2FontawesomeModule });
Angular2FontawesomeModule.ɵinj = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjector({ imports: [CommonModule] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(FaDirective, [{
        type: Directive,
        args: [{
                selector: "[fa]",
                inputs: [
                    "name",
                    "alt",
                    "size",
                    "stack",
                    "flip",
                    "pull",
                    "rotate",
                    "border",
                    "spin",
                    "fw",
                    "inverse"
                ]
            }]
    }], function () { return [{ type: ɵngcc0.ElementRef }]; }, null); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(FaComponent, [{
        type: Component,
        args: [{
                selector: "fa",
                template: FA_COMPONENT_TEMPLATE
            }]
    }], function () { return [{ type: ɵngcc0.ElementRef }]; }, { name: [{
            type: Input
        }], alt: [{
            type: Input
        }], size: [{
            type: Input
        }], stack: [{
            type: Input
        }], flip: [{
            type: Input
        }], pull: [{
            type: Input
        }], rotate: [{
            type: Input
        }], border: [{
            type: Input
        }], spin: [{
            type: Input
        }], fw: [{
            type: Input
        }], inverse: [{
            type: Input
        }] }); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(Angular2FontawesomeModule, [{
        type: NgModule,
        args: [{
                imports: [CommonModule],
                declarations: [FaDirective, FaComponent],
                exports: [FaDirective, FaComponent]
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(Angular2FontawesomeModule, { declarations: function () { return [FaDirective, FaComponent]; }, imports: function () { return [CommonModule]; }, exports: function () { return [FaDirective, FaComponent]; } }); })();

/*
 * Public API Surface of angular2-fontawesome
 */

/**
 * Generated bundle index. Do not edit.
 */

export { Angular2FontawesomeModule, FaComponent, FaDirective };

